import styled from 'styled-components'

export const TopSection = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 40px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e0e0e0;
`

export const UnitText = styled.span`
  font-size: 14px;
  font-weight: 600;
  margin-left: 8px;
  align-self: center;
  white-space: nowrap;
`

export const KoreanAmountText = styled(UnitText)`
  margin-left: 18px;
  color: #888;
  font-weight: 500;
`

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  min-height: 92px;
`

export const OpexModeControl = styled.div`
  display: flex;
  align-items: flex-start;

  > div:last-child {
    padding: 8px 12px;
    background: #ffffff;
  }
`

export const AddButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const SummaryCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 96px;
  padding: 18px 20px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`

export const SummaryCardLabel = styled.div`
  font-family: SUIT;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  color: #2f3c5e;
  margin-bottom: 10px;
`

export const SummaryCardBody = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
`

export const SummaryCardValue = styled.span`
  font-family: SUIT;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  color: #333333;
`

export const SummaryCardUnit = styled.span`
  font-family: SUIT;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #333333;
`

export const SummaryCardKoreanAmount = styled.span`
  font-family: SUIT;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  color: #888888;
`

export const ListHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) 40px;
  gap: 10px;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #666;
  align-items: center;
`

export const ListItemRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) 40px;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
`

export const DeleteBtn = styled.button`
  border: none;
  background: transparent;
  color: #ff4d4f;
  cursor: pointer;
  font-size: 13px;
  width: 40px;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
`

export const StyledSelect = styled.select`
  padding: 11px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: white;
  width: 100%;
`
